<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <div class="page-wrapper">
    <div class="content">
      <div class="page-header">
        <div class="add-item d-flex">
          <div class="page-title">
            <h4>Campaign</h4>
            <h6>Create Campaign</h6>
          </div>
        </div>
        <ul class="table-top-head">

          <li>
            <a ref="collapseHeader" data-bs-toggle="tooltip" data-bs-placement="top" title="Collapse"
               @click="toggleCollapse(collapseHeader.value)">
              <i data-feather="chevron-up" class="feather-chevron-up"></i>
            </a>
          </li>
        </ul>
        <div class="page-btn d-flex gap-1">
          <a @click="saveCampaign()" href="javascript:void(0);" class="btn btn-added">
            <vue-feather type="plus-circle"
                         class="me-2"></vue-feather>
            Save</a>

          <router-link style="color: var(--PRIMARY-COLOR) !important;" :to="cancelRoute"
                       class="btn btn-added bg-white">
            <vue-feather type="x" class="me-2"></vue-feather>
            Cancel
          </router-link>
        </div>
      </div>


      <div class="row">
        <!-- Form -->
        <div class="col-lg-8">
          <div class="card">
            <div class="card-body">
              <CampaignForm ref="campaignForm" v-model="campaign" />
            </div>
          </div>
        </div>

        <!-- Preview -->
        <div class="col-lg-4">
          <CampaignPreview :campaign="campaign" />
        </div>
      </div>




    </div>
  </div>

</template>

<script setup>

import {toggleCollapse} from "@/utils/components";
import {useCampaignStore} from "@/store/campaignStore";
import CampaignForm from './components/campaign-form.vue';
import CampaignPreview from './components/campaign-preview.vue';
import {ref} from "vue";
import {useRoute, useRouter} from "vue-router";

const cancelRoute = {name: "campaign-list"};
const campaignStore = useCampaignStore();
const collapseHeader = ref(null);
const route = useRoute();
const router = useRouter();
const campaignForm = ref(null);

const campaign = ref({
  greeting: '',
  description: '',
  type: '',
  start_date: '',
  end_date: '',
  action_text: '',
  action_url: '',
  color_code: '',
  message: '',
  amount: null,

  media_item_id: null,
  media_item_url: null,
  amount_raised: null
});

function formatDateForApi(value) {
  if (!value) {
    return null;
  }

  return value.replace('T', ' ') + ':00';
}

function buildPayload() {
  return {
    greeting: campaign.value.greeting,
    description: campaign.value.description,
    type: campaign.value.type,

    start_date: formatDateForApi(campaign.value.start_date),
    end_date: formatDateForApi(campaign.value.end_date),

    action_text: campaign.value.action_text,
    action_url: campaign.value.action_url,
    color_code: campaign.value.color_code,
    message: campaign.value.message,
    amount: campaign.value.amount,

    media_item_id: campaign.value.media_item_id,
  };
}

async function saveCampaign() {
  if (!campaignForm.value.validate()) {
    return;
  }

  try {
    const payload = buildPayload();

    const success = await campaignStore.addCampaign(payload);

    if (success) {
      await router.push({name: "campaign-list"});
    }

  } catch (error) {

  }

}
</script>

<style>

</style>